import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { userQueryKeys } from "@/company/data/userQueryKeys";
import { UsersBody } from "@reflag/shared/userAPI";

export function useUsersData(body?: Omit<UsersBody, "envId">, enabled = true) {
  const { appId, envId } = useEnvironment();

  return useQuery({
    queryKey: userQueryKeys.list(appId, envId, body),
    queryFn: () =>
      api
        .post<`/apps/:appId/users`>(`/apps/${appId}/users`, body, {
          params: {
            envId: envId!,
          },
        })
        .then((res) => res.data),
    enabled: !!appId && !!envId && enabled,
    placeholderData: keepPreviousData,
  });
}
